import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5f066db2&scoped=true"
import script from "./accountingFlexField.js?vue&type=script&lang=js&external"
export * from "./accountingFlexField.js?vue&type=script&lang=js&external"
import style0 from "./accountingFlexField.css?vue&type=style&index=0&id=5f066db2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f066db2",
  null
  
)

export default component.exports